module.exports = __webpack_public_path__ + "static/media/achesoothe-5.d48f83ae.png";